<template>
  <div class="page-activity" :class="{'mobile': _isMobile}">
    <div class="activity-wrap " :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="12"></cmpBanner>

      <div class="g-wrap">
        <div class="g-content">
          <div class="top-box">
            <div class="pic-box" v-if="detailData.picture">
              <img v-lazy="detailData.picture">
            </div>

            <div class="info">
              <div class="label-box m-font-4">
                <p class="txt">
                  <label>规格: </label>
                  <span>{{detailData.size}}</span>
                </p>
                <p class="txt">
                  <label>材质: </label>
                  <span>{{detailData.texture}}</span>
                </p>
              </div>

              <div class="label-box m-font-4">
                <p class="txt">
                  <label>重量: </label>
                  <span>{{detailData.position}}</span>
                </p>
                <p class="txt">
                  <label>包装: </label>
                  <span>{{detailData.type}}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="con">
            <h1 class="title-box mb-30">
              <span><i>文</i></span>
              <span><i>创</i></span>
              <span><i>详</i></span>
              <span><i>情</i></span>
            </h1>
            <p class="name mb-30">{{detailData.name}}</p>
            <cmpDetail :detailData="detailData" :hideName="true"></cmpDetail>
            <!-- <div class="g-detail-html trans">
              <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolorum qui, quidem numquam modi eveniet debitis id nulla expedita architecto accusamus ipsam iusto doloribus sit autem, repellendus dolor recusandae. Perspiciatis, libero?</p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/product/detail.scss'
export default {
  data() {
    return {
      pageType: this.$route.query.pageType,
      detailData: {
        content: ''
      },
      detailId: this.$route.query.id,
    }
  },
  methods: {
    getDetailData() {
      this.dataList = []

      this.listLoading = true
      this.$http
        .get('/webapi/culturalcreative/detail', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.data
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    setBread() {
      console.log('00', this.pageType)
      switch(this.pageType) {
        case '1':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '社教活动',
              href: '/activity?pageType=1'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '2':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '游学活动',
              href: '/activity?pageType=2'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '3':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '讲座',
              href: '/activity?pageType=3'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '4':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '手工',
              href: '/activity?pageType=4'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '5':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '其他',
              href: '/activity?pageType=5'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
      }
    }
  },
  created() {
    // this.setBread()
    this.getDetailData()
  }
}
</script>

<style lang="scss" scoped>
.activity-wrap {
  .g-detail-html {
    width: 100%;
  }

  .top-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    .pic-box {
      padding: 50px 80px;
      width: 744px;
      height: 510px;
      box-sizing: border-box;
      background: url(~@images/pic_bg.png) no-repeat center center;
      background-size: 100% 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .info {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      .label-box {
        color: #0E0E0E;
        .txt {
          margin-bottom: 10px;
        }
        &:first-child {
          margin-right: 100px;
        }
      }
    }
  }

  .con {
    margin-top: 60px;
    .title-box {
      font-size: 32px;
      color: #fff;
      display: flex;
      justify-content: center;
      span {
        margin: 0 7px;
        padding: 5px;
        border: solid 1px #880000;
        border-radius: 100%;
        i {
          display: inline-block;
          padding: 1px 10px 7px 10px;
          background: #880000;
          border-radius: 100%;
        }
      }
    }
    .name {
      font-size: 32px;
      color: #000000;
      text-align: center;
    }
  }
}
</style>


